module.exports = __webpack_public_path__ + "img/Pattern03.df6689f4.png";